import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 4,
    label: 'NAME_KEY',
    stateKey: 'first_name',
    validateOnChange: true,
  },
  {
    gridXs: 4,
    label: 'LAST_NAME_KEY',
    stateKey: 'last_name',
    validateOnChange: true,
  },
  {
    gridXs: 4,
    label: 'EMAIL_KEY',
    stateKey: 'email',
  },
  {
    gridXs: 4,
    label: 'LANGUAGE_KEY',
    stateKey: 'language',
    isSelect: true,
    options: [
      { value: 'pt-br', label: 'LANGUAGES.PORTUGUESE_KEY' },
      { value: 'en', label: 'LANGUAGES.ENGLISH_KEY' },
      { value: 'es', label: 'LANGUAGES.SPANISH_KEY' },
    ],
  },
  {
    gridXs: 4,
    label: 'ROLE_KEY',
    stateKey: 'role',
    isSelect: true,
    options: [
      { value: 'superadmin', label: 'ROLES.SUPERADMIN_KEY' },
      { value: 'admin', label: 'ROLES.ADMIN_KEY' },
      { value: 'operator', label: 'ROLES.OPERATOR_KEY' },
      { value: 'client_operator', label: 'ROLES.CLIENT_OPERATOR_KEY' },
    ],
  },
  {
    gridXs: 4,
    label: 'COMPANY_KEY',
    stateKey: 'company.company_uuid',
    isSelect: true,
    options: [],
  },
  {
    gridXs: 4,
    label: 'PASSWORD_KEY',
    stateKey: 'password',
    isPassword: true,
    validateOnChange: true,
  },
];

export const resetFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'NEW_PASSWORD_KEY',
    stateKey: 'password',
    isPassword: true,
  },
  {
    gridXs: 12,
    label: 'CONFIRM_NEW_PASSWORD_KEY',
    stateKey: 'password_confirmation',
    isPassword: true,
  },
  {
    gridXs: 12,
    label: 'YOUR_PASSWORD_KEY',
    stateKey: 'current_password',
    isPassword: true,
  },
];

export default fields;
